<template>
    <!-- 流向商业配置 批量关联流向 -->
    <vFlowConfig01FlowListComponent :postList="postList" v-if="flag"></vFlowConfig01FlowListComponent>
</template>
<script>
import vFlowConfig01FlowListComponent from '../../listComponent/basicdata/flowConfig01/flowConfig01FlowListComponent.vue';
export default {
    name: 'flowConfig01FlowList',
    components: {
        vFlowConfig01FlowListComponent
    },
    data() {
        return {
            postList: {
                headerTitle: true,
                source_file: true,
                batchSaveBtn: true,
                searchBtn: true,
                resetBtn: true,
                setBtn: true
            },
            flag: false
        };
    },
    mounted() {
        this.flag = false;
        this.$nextTick(() => {
            this.flag = true;
        });
    },
    methods: {}
};
</script>
<style lang="scss" scoped="scoped">
</style>